<template>
  <md-card>
    <md-card-header md-alignment="space-between">
      <h4 class="title">
        <md-icon>assignment</md-icon>
        납부 내역
      </h4>
    </md-card-header>
    <md-card-content>
      <div class="table-header-info">
        <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
        <div>
          <select v-model="pagination.perPage" name="pages" @change="perPageChange">
            <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>

      <grid ref="branchFeeListGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @dblclick="onDbClickBranchFee"
            @click="onClickBranchFee"
            @response="response"
      ></grid>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-danger md-sm" @click="deleteFeeItem" :disabled="!selectedRow">
        <md-icon>clear</md-icon>
        삭제
      </md-button>
    </md-card-actions>
  </md-card>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

import Swal from "sweetalert2";

export default {
  name: "GroupFeeListComp",
  props: {
  },
  components: {
    grid: Grid
  },

  created() {
      this.initGrid();
  },

  computed: {
      total: function() {
        return this.pagination.total
      }
  },
  data() {
    return {
      branchId : null,
      selectedRow : null,
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      }
    };
  },
  methods: {
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_BRANCH_FEE_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.branchFeeListGrid;
      this.gridProps['columns']= [
          {header: null, name: '선택', align : 'center', width : 60,
            formatter(value) {
              return '<input type="radio" id="radio' + value.row.feeTime + '" name="selectedFee">';
            }
          },
          {header: '납부일자', name: 'feeDate', align : 'center', sortable: true},
          {header: '납부교우번호', name: 'memberNo', align : 'center', sortable: true,
            formatter(value) {
              return `<span style="color:#0091d5; text-decoration:underline; cursor:pointer">${value.value}</span>`;
            }
          },
          {header: '교우명', name: 'memberHnm', align : 'center', sortable: true},
          {header: '금액', name: 'feeAmt', align : 'right', sortable: true,
            formatter(value) {
              return formatter.getCurrency(value.value);
            }
          },
          {header: '납부인원수', name: 'feeCnt', align : 'right', sortable: true,
            formatter(value) {
              return formatter.getCurrency(value.value);
            }
          },
          {header: '납부방법', name: 'feeWayNm', align : 'center', sortable: true},
          {header: '회비년도', name: 'feeYear', align : 'center', sortable: true},
          {header: '학과', name: 'classCdNm', align : 'center', sortable: true},
          {header: '납부번호', name: 'feeTime', hidden : true}
        ];
      this.gridProps['options'].bodyHeight = 200;
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.branchFeeListGrid, event, this.pagination);
    },
    sendQuery (branchId) {
      if(branchId){
        this.branchId = branchId;
      }
      this.$refs.branchFeeListGrid.invoke("readData", 1, {branchId : branchId});
    },
    onClickBranchFee (e){
      if(e.columnName === '선택' && e.instance.getRow(e.rowKey) != null) {
        let obj = e.instance.getRow(e.rowKey);
        this.selectedRow = obj;
        // 그리드 선택
        document.getElementById('radio' + obj.feeTime).checked = true;
        this.$emit('returnResult', e.instance.getRow(e.rowKey));
      }
    },
    onDbClickBranchFee(e) {
      if(e.columnName === "memberNo" && e.instance.getRow(e.rowKey) != null) {

        this.$emit('setExcutiveData', e.instance.getRow(e.rowKey));
        window.open('/Friendship/UpdateMember/' + e.instance.getRow(e.rowKey).memberNo, 'FriendshipUpdateMember');
      }
    },

    deleteFeeItem() {
      let param = {
        branchId : this.branchId,
        feeDate : this.selectedRow.feeDate,
        feeTime : this.selectedRow.feeTime
      }
      let modalOptions = {
        title: "단체 회비 납부내역 삭제",
        type: "warning",
        showCancelButton: false,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-default",
        confirmButtonText: "확인",
        buttonsStyling: false
      };

      kuaaApi.sendServer(
        URL_CONST.DELETE_BRANCH_FEE,
        param,
        "post",
        response => {
          if (response.data.success){
			modalOptions.html = `단체 회비가 삭제 되었습니다.`;
	        Swal.fire(modalOptions);
            this.selectedRow = null;
            this.sendQuery(param.branchId);
            this.$emit('returnResult', null);
          } else {
            modalOptions.html = `단체 회비 삭제가 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    }
  }
};
</script>

<style lang="css" scoped>

</style>